import { CommonModule } from '@angular/common';
import { Component,  OnInit, } from '@angular/core';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';
import { JobOfferListComponent } from "./job-offer-list/job-offer-list.component";

@Component({
    selector: 'app-job-offer-candidates',
    templateUrl: './job-offer-candidates.component.html',
    styles: [],
    standalone: true,
    imports: [CarouselComponent, CommonModule, JobOfferListComponent]
})
export class JobOfferCandidatesComponent implements OnInit {
  ngOnInit(): void {
  }
 
}